import { cn } from "@/lib/utils";
import markUrl from "@/assets/brand/vp-mark.svg";
import markReverseUrl from "@/assets/brand/vp-mark-reverse.svg";

/**
 * The VP mark + "VP Signal" wordmark, from the VP family brand (VP Trop).
 * Full-colour mark (lime V, teal P) on light grounds, reverse mark (lime V,
 * white P) on dark ones, because the teal P vanishes on dark. The wordmark is
 * Unbounded ExtraBold, uppercase.
 */
export function BrandMark({ collapsed = false, className }: { collapsed?: boolean; className?: string }) {
	return (
		<span className={cn("flex items-center gap-2.5", className)}>
			<img src={markUrl} alt="" aria-hidden className="h-7 w-auto shrink-0 dark:hidden" />
			<img src={markReverseUrl} alt="" aria-hidden className="hidden h-7 w-auto shrink-0 dark:block" />
			{collapsed ? (
				<span className="sr-only">VP Signal</span>
			) : (
				<span className="whitespace-nowrap font-display text-[0.9375rem] font-extrabold uppercase leading-none tracking-[-0.01em] text-foreground">
					VP Signal
				</span>
			)}
		</span>
	);
}
